// load more buttons
document.querySelectorAll('.collectionButton')?.forEach(button => {
    button.addEventListener('click', async function () {
        await document.querySelectorAll('.collectionItem')?.forEach(item => item.classList.add('active'));
        this.remove();
    })
})

// truncated text toggle
document.querySelector('#collectionDescriptionTruncatedButton')?.addEventListener('click', function () {
    this.closest('#collectionDescription').classList.add('active');
})

// collection item atc
document.querySelectorAll('.collectionItemATC').forEach(button => {
    button.addEventListener('click', async function (e) {
        // card is a link, ignore
        e.preventDefault();

        // add product
        try {
            await addProduct({
                items: [{
                    quantity: 1,
                    id: this.dataset.id,
                }]
            });
        } catch (err) {
            console.error(err);
            return;
        }

        // open cart
        await openCart();
    })
})